import { useAmplitude, useEffectOnce } from '@app/utils/hooks';
import { useUrlLookbookProductId } from '@app/utils/hooks/useUrlLookbookProductId';
import { useUrlLookbookVariantId } from '@app/utils/hooks/useUrlLookbookVariantId';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { LookbookHeader } from '../header/LookboookHeader';
import { PageTitle } from '../various/PageTitle';

import { LookbookContextProvider } from './context/LookbookContext';
import { LookbookProductsContextProvider } from './context/LookbookProductsContext';
import { LookbookWishlistContextProvider } from './context/LookbookWishlistContext';
import { LookbookProductsPageContent } from './LookbookProductsPageContent';
import { LookbookTopBar } from './LookbookTopBar';

export const LookbookProductsPage = () => {
  const { lookbookId, wishlistId } = useParams<{ lookbookId: string; wishlistId?: string }>();
  const productId = useUrlLookbookProductId();
  const variantId = useUrlLookbookVariantId();
  const { t } = useTranslation(['products']);
  const { trackEvent } = useAmplitude();

  useEffectOnce(() => {
    trackEvent({ name: 'lookbookPage.page.opened' });
  });

  if (!isDefined(lookbookId)) {
    return null;
  }

  return (
    <PageTitle title={t('products:product_other')}>
      <LookbookContextProvider key={lookbookId} lookbookId={lookbookId} locationContext="products">
        <LookbookProductsContextProvider productId={productId}>
          <LookbookWishlistContextProvider wishlistId={wishlistId}>
            <LookbookHeader lookbookId={lookbookId} />
            <LookbookTopBar lookbookId={lookbookId} isProductsPage />
            <LookbookProductsPageContent variantId={variantId} productId={productId} />
          </LookbookWishlistContextProvider>
        </LookbookProductsContextProvider>
      </LookbookContextProvider>
    </PageTitle>
  );
};
